/**
 * @param zTreeObj
 * @param keywords 模糊搜索的内容
 * @param isHighLight 是否高亮,默认高亮,传入false禁用
 * @param isExpand 是否展开,默认合拢,传入true展开
 *
 * @returns
 */
export function fuzzySearch(zTreeObj, keywords, isHighLight = true, isExpand = true) {
  if (!zTreeObj) {
    alert("fail to get ztree object");
  }
  let nameKey = zTreeObj.setting.data.key.name; //get the key of the node name
  zTreeObj.setting.view.nameIsHTML = isHighLight; //allow use html in node name for highlight use

  const metaChar = "[\\[\\]\\\\\^\\$\\.\\|\\?\\*\\+\\(\\)]"; //js meta characters
  const rexMeta = new RegExp(metaChar, "gi");//regular expression to match meta characters

  // keywords filter function
  function ztreeFilter(zTreeObj, _keywords, callBackFunc) {
    if (!_keywords) {
      _keywords = ""; //default blank for _keywords
    }

    // function to find the matching node
    function filterFunc(node) {
      if (node && node.oldname && node.oldname.length > 0) {
        node[nameKey] = node.oldname; //recover oldname of the node if exist
      }
      zTreeObj.updateNode(node); //update node to for modifications take effect
      if (_keywords.length === 0) {
        //return true to show all nodes if the keyword is blank
        zTreeObj.showNode(node);
        // node.isHidden=false
        zTreeObj.expandNode(node, false);
        return true;
      }
      //transform node name and keywords to lowercase
      if (node[nameKey] && node[nameKey].toLowerCase().indexOf(_keywords.toLowerCase()) !== -1) {
        if (isHighLight) { //highlight process
          //a new variable 'newKeywords' created to store the keywords information
          //keep the parameter '_keywords' as initial and it will be used in next node
          //process the meta characters in _keywords thus the RegExp can be correctly used in str.replace
          const newKeywords = _keywords.replace(rexMeta, function (matchStr) {
            //add escape character before meta characters
            return "\\" + matchStr;
          });
          node.oldname = node[nameKey]; //store the old name
          const rexGlobal = new RegExp(newKeywords, "gi");//'g' for global,'i' for ignore case
          // use replace(RegExp,replacement) since replace(/substr/g,replacement) cannot be used here
          node[nameKey] = node.oldname.replace(rexGlobal, function (originalText) {
            // highlight the matching words in node name
            return `<span style="color: whitesmoke;background-color: #038dce;">${originalText}</span>`;
          });
          zTreeObj.updateNode(node); //update node for modifications take effect
        }
        // node.isHidden=false;
        zTreeObj.showNode(node);//show node with matching keywords
        return true; //return true and show this node
      }
      // node.isHidden=true;
      zTreeObj.hideNode(node); // hide node that not matched
      return false; //return false for node not matched
    }

    const nodesShow = zTreeObj.getNodesByFilter(filterFunc); //get all nodes that would be shown
    processShowNodes(nodesShow, _keywords);//nodes should be reprocessed to show correctly
  }

  /**
   * reprocess of nodes before showing
   */
  function processShowNodes(nodesShow, _keywords) {
    if (nodesShow && nodesShow.length > 0) {
      //process the ancient nodes if _keywords is not blank
      if (_keywords.length > 0) {
        $.each(nodesShow, function (n, obj) {
          const pathOfOne = obj.getPath();//get all the ancient nodes including current node
          if (pathOfOne && pathOfOne.length > 0) {
            //i < pathOfOne.length-1 process every node in path except self
            for (var i = 0; i < pathOfOne.length - 1; i++) {
              zTreeObj.showNode(pathOfOne[i]); //show node
              zTreeObj.expandNode(pathOfOne[i], true); //expand node
            }
          }
        });
      } else { //show all nodes when _keywords is blank and expand the root nodes
        const rootNodes = zTreeObj.getNodesByParam("level", "0");//get all root nodes
        $.each(rootNodes, function (n, obj) {
          zTreeObj.expandNode(obj, true); //expand all root nodes
        });
      }
    }
  }

  ztreeFilter(zTreeObj, keywords); //lazy load ztreeFilter function
}

export function debounce(fn, delay = 500,that) {
  // 函数防抖在执行目标方法时，会等待一段时间
  if (that._timer) {
    clearTimeout(that._timer)
  }
  that._timer = setTimeout(() => {
    fn();
    that._timer = null
  }, delay)
}
export function throttle(fn, delay=500,that) {
  // 在延时的时间内，方法若被触发，则直接退出方法
  if (that._timer) {
    return
  }
  that._timer = setTimeout(() => {
    fn();
    that._timer = null
  },delay)
}




// WEBPACK FOOTER //
// ./src/components/Admin/Common/ztree/fuzzysearch.js